

const rgbToHsl = require('../rgb/toHsl');
const hexToRgb = require('./toRgb');

module.exports = (hex) => rgbToHsl(hexToRgb(hex));



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/toHsl.js